import { DEFAULT_LOCALE } from "../../constants";

// old/new format match hash talbe
const matches = {
  se: 'sv-SE',
  sv: 'sv-SE',
  en: 'en-GB',
  de: 'de-DE',
  nb: 'nb-NO',
  it: 'it-IT',
  pl: 'pl-PL',
  fr: 'fr-FR',
  ar: 'ar-AR',
  es: 'es-ES',
  zh: 'zh-CN',
  da: 'da-DK',
  nl: 'nl-NL',
  hu: 'hu-HU',
  cs: 'cs-CZ',
  fi: 'fi-FI',
  no: 'nb-NO',
  so: 'so-SO',
  ru: 'ru-RU',
  bg: 'bg-BG',
  ro: 'ro-RO',
  cn: 'zh-CN',
  pt: 'pt-BR',
};

const matchesReverse = {
  'en-US': 'en',
  'en-GB': 'en',
  'sv-SE': 'sv',
  'de-DE': 'de',
  'nb-NO': 'nb',
  'it-IT': 'it',
  'pl-PL': 'pl',
  'fr-FR': 'fr',
  'ar-AR': 'ar',
  'es-ES': 'es',
  'zh-CN': 'zh',
  'da-DK': 'da',
  'nl-NL': 'nl',
  'hu-HU': 'hu',
  'cs-CZ': 'cs',
  'fi-FI': 'fi',
  'so-SO': 'so',
  'ru-RU': 'ru',
  'bg-BG': 'bg',
  'ro-RO': 'ro',
  'en-IE': 'en',
  'pt-BR': 'pt',
};



function getTranslatedText(translations, language) {

  if (!language) {
    language = DEFAULT_LOCALE;
  }

  if (!translations) {
    return '';
  }

  if (!Array.isArray(translations)) {
    if (!!translations.text) {
      return translations.text;
    }
    return '';
  }

  let translation = translations.find(t => t.language === language);
  // ToDo:
  // once new format is applied to the db
  // remove this check nad re-write this function
  if (!translation && !!matchesReverse[language]) {
    translation = translations.find(t => t.language === matchesReverse[language]);
  }

  if (!translation && !!matches[language]) {
    translation = translations.find(t => t.language === matches[language]);
    if (!translation && language === 'en') {
      translation = translations.find(t => t.language === 'en-GB');
    }
  }
  // end of check

  if (!!translation) {
    return translation.text || '';
  }

  // Take any translation
  // if no translation is ofund by language code
  if (translations.length >= 1) {
    return translations[0].text;
  }
  return '';

}

export default getTranslatedText;



// WEBPACK FOOTER //
// ./src/services/getTranslatedText/getTranslatedText.js